
<div class="social-share-buttons d-flex">
  <div v-for="(data, provider) in providers" :key="data" class="social-share-button mr-1" :class="providerClass(provider)" @click="openShare(provider)">
    <i :class="data.icon"></i>
    <small v-text="provider"></small>
  </div>
</div>
